import React from 'react';
import './EightBallIcon.css';

interface EightBallIconProps {
  size?: string;
  className?: string;
}

const EightBallIcon: React.FC<EightBallIconProps> = ({ className = '' }) => {
  return (
    <div className={`eight-ball-icon ${className}`}>
      {/* White circle background for the "8" */}
      <div className="eight-ball-inner">
        8
      </div>
    </div>
  );
};

export default EightBallIcon; 